import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box} from 'views/components';

import ClientTitle from './title/ClientTitle';
import ClientDescription from './description/ClientDescription';
import ClientPhoto from './photo/ClientPhoto';
import ClientShowSettings from './ClientShowSettings';
import ClientAnnouncement from './announcement/ClientAnnouncement';

const ClientHeader = (props) => {
  const clientRn = props.clientRn;
  const clientData = props.clientData;
  const clientBackend = props.clientBackend;
  const refresh = props.refresh;
  const setRefresh = props.setRefresh;
  const showSettings = props.showSettings;
  const setOpenDrawerView = props.setOpenDrawerView;

  return (
    <Stack>
      <ClientTitle
        clientRn={clientRn}
        clientData={clientData}
        clientBackend={clientBackend}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <Stack direction={{md: 'row', xs: 'column'}}>
        <Box
          sx={{
            width: {md: '20%', xs: '100%'},
          }}
        >
          <ClientPhoto
            clientRn={clientRn}
            clientData={clientData}
            clientBackend={clientBackend}
          />
        </Box>
        <Box
          sx={{
            width: {md: '80%', xs: '100%'},
          }}
        >
          <ClientDescription
            clientRn={clientRn}
            clientData={clientData}
            clientBackend={clientBackend}
          />
        </Box>
      </Stack>
      <ClientAnnouncement
        clientRn={clientRn}
        clientData={clientData}
        clientBackend={clientBackend}
      />
      <ClientShowSettings
        clientRn={clientRn}
        clientData={clientData}
        clientBackend={clientBackend}
        showSettings={showSettings}
        setOpenDrawerView={setOpenDrawerView}
      />
    </Stack>
  );
};
ClientHeader.propTypes = {
  clientRn: PropTypes.string.isRequired,
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
  showSettings: PropTypes.bool.isRequired,
  setOpenDrawerView: PropTypes.func.isRequired,
};

export default React.memo(ClientHeader);
